import tags from '../tags';

const {
  passives: {
    offensivePassive,
    defensivePassive,
    resourcePassive,
    healingPassive,
    cooldownPassive,
  },
} = tags;

export default [
  {
    name: 'Heavenly Strength',
    tags: [],
  },
  {
    name: 'Fervor',
    tags: [offensivePassive, cooldownPassive],
  },
  {
    name: 'Vigilant',
    tags: [defensivePassive, healingPassive],
  },
  {
    name: 'Righteousness',
    tags: [resourcePassive],
  },
  {
    name: 'Insurmountable',
    tags: [resourcePassive],
  },
  {
    name: 'Fanaticism',
    tags: [offensivePassive],
  },
  {
    name: 'Indestructible',
    tags: [defensivePassive],
  },
  {
    name: 'Holy Cause',
    tags: [offensivePassive, healingPassive],
  },
  {
    name: 'Wrathful',
    tags: [healingPassive],
  },
  {
    name: 'Divine Fortress',
    tags: [defensivePassive],
  },
  {
    name: 'Lord Commander',
    tags: [cooldownPassive, offensivePassive],
  },
  {
    name: 'Long Arm of the Law',
    tags: [],
  },
  {
    name: 'Iron Maiden',
    tags: [offensivePassive],
  },
  {
    name: 'Renewal',
    tags: [healingPassive],
  },
  {
    name: 'Finery',
    tags: [offensivePassive, defensivePassive],
  },
  {
    name: 'Blunt',
    tags: [offensivePassive],
  },
  {
    name: 'Towering Shield',
    tags: [offensivePassive, cooldownPassive],
  },
];
